module.exports = __webpack_public_path__ + "img/product-placeholder-24.70ec643.png";